import React from "react";
import {
    Theme,
    StandardProps,
    Typography,
    IconButton
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";
import { DirectoryItem } from "js/react/scenes/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            borderLeft: `1px solid ${theme.palette.grey["300"]}`,
            borderRight: `1px solid ${theme.palette.grey["300"]}`,
            padding: theme.spacing(0.5, 1),
            minWidth: "100px",
            alignItems: "center"
        },
        delIcon: {
            fontSize: "0.8rem",
            color: theme.palette.common.black,
            padding: theme.spacing(0.4)
        },
        dirName: {
            flexGrow: 1,
            margin: theme.spacing(0.5, 1),
            fontSize: "0.925rem",
            cursor: "pointer",
            fontWeight: 600,
            color: theme.palette.secondary.main
        },
        icon: {
            color: theme.palette.secondary.light
        },
        dirIcon: {
            fontSize: "1.1rem"
        }
    });

type DirectoryBreadCrumbItemClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface DirectoryBreadCrumbItemProps
    extends StandardProps<{}, DirectoryBreadCrumbItemClassKey> {
    directory: DirectoryItem;
    active: boolean;
    onClick: () => void;
    onDelete: () => void;
}

function Component(props: DirectoryBreadCrumbItemProps) {
    const classes = useStyles(props);
    const { directory, onDelete, active, onClick } = props;

    return (
        <div className={classes.root}>
            <FontAwesomeIcon
                icon={["fas", "folder"]}
                className={clsx(classes.icon, classes.dirIcon)}
            />
            <Typography
                variant="body1"
                className={classes.dirName}
                onClick={() => {
                    if (!active) {
                        onClick();
                    }
                }}
            >
                {directory.displayName}
            </Typography>
            {active && (
                <IconButton className={classes.delIcon} onClick={onDelete}>
                    <FontAwesomeIcon icon={["fal", "times"]} />
                </IconButton>
            )}
        </div>
    );
}

Component.defaultProps = {} as DirectoryBreadCrumbItemProps;
Component.displayName = "DirectoryBreadCrumbItem";
export const DirectoryBreadCrumbItem = Component;
export default DirectoryBreadCrumbItem;
